<template>
  <div class="product col-sm-12 m-0 p-1 clearfix">
	  <div class="d-flex align-items-center justify-content-start">
      <img class="product-image inline" :src="product.image_url" :alt="product.sku" />
		  <div class="px-2">
			  <p class="widget-product-manufacturer mb-0">{{product.sku}} {{ product.manufacturer }} </p>
			  <p class="font-weight-bold mb-0">{{ product.name }}</p>
		  </div>
	  </div>
    <div class="row">
    <div class="m-0 col-5">
    <PriceDisplay :product="product"/>
  </div>
      <div class="m-0 col-7">

    <button 
    class="btn btn-success btn-sm widget-icon right ml-2 compact float-right"
    @click="quickAddProduct(product)"
    >
      <i class="fas fa-cart-plus"></i> Add to Order
    </button>
  </div>
  </div>
  </div>
</template>

<script>
  import PriceDisplay from '@/Components/Shop/PriceDisplay'

  export default {
    components: {
    	PriceDisplay
    },
    props: {
      product: Object,
      suggested_type: String
    },
    data() {
      return {
        formCart: this.$inertia.form({
          qty: null,
          product_id: null,
          is_suggested: 1,
          suggested_type: this.suggested_type
        }),
        productLink: "mtd.wholesale.view",
        isWholesale: true
      }
    },
    methods: {
      update() {
        this.$emit('onUpdate')
      },
      quickAddProduct(product) {
        if (this.formCart.processing) return

        this.formCart.qty = 1,
        this.formCart.product_id =  product.id

        this.formCart.post(this.route(this.isWholesale ? 'mtd.cart.add' : 'cart.add', product.id), { 
          preserveScroll: true,
          onSuccess: () => {
            this.update() 
            this.trackAddToCart(
              product,
              1,
              this.$page.props
            );
          }
        })
      },
    }
  }
</script>

<style scoped>
  .product-image {
    max-width: 70px;
    object-fit: cover;
  }

  .product-image.compact {
    max-height: 70px;
  }

  .product-image.inline {
    max-height: 70px;
  }

  .slot-container {
    flex: 1;
  }

  @media (min-width: 992px) {
    .product-image {
      max-height: 75px;
    }
  }
</style>